// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import DropdownArrow from '../../../assets/images/dropdown-arrow.svg';
import ButtonActive from '../../../assets/images/button-active.svg';
export interface typeList {
  key: string,
  message: string
}

interface CourseDropdownProps {
  type: string;
  typeList: typeList[];
  updateType: (nextCourse: string) => void;
}

const S = {
  Container: styled.div`
    width: 200px;
    padding: 0 15px;
    height: 30px;

    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #9d9d9d;
    cursor: pointer;
    z-index: 99;
    background-color: #efefef87;
  `,
  Current: styled.div`
    font: 16px Noto Sans TC;
    color: #A6A6A6;
  `,
  DropdownArrow: styled.img.attrs({ src: DropdownArrow, alt: 'dropdown-arrow' }) <{ isOpened: boolean }>`
    width: 14px;
    height: 10px;
    transition: all .5s;
    margin-left: auto;
    transform: rotate(${props => props.isOpened ? '0deg' : '180deg'});
  `,
  DropContainer: styled.div`
    width: 100%;
    position: absolute;
    top: 30px;
    left: 0px;
    background: #FFF;
    border-radius: 4px;
    box-shadow: 0px 2px 4px 0px #00000040;
  `,
  DropRow: styled.div`
    height: 50px;
    padding: 0 15px;
    display: flex;
    align-items: center;

    &:hover {
      background: rgba(201,201,201,0.3);
    }
  `,
  OptionTitle: styled.div<{ active?: boolean }>`
    font: 16px Noto Sans TC;
    color: #666666;
    ${props => props.active ? 'font-weight: 500;' : 'margin-left: 18px;'}
  `,
  ActiveTypeIcon: styled.img.attrs({ src: ButtonActive, alt: 'dropdown-arrow' })`
    margin-right: 10px;
  `,
}

function CourseFilter(props: CourseDropdownProps): JSX.Element {
  const {
    type,
    updateType,
    typeList,
    ...otherProps
  } = props;

  const [isOpened, setIsOpened] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleDrop = () => {
    if (isOpened) {
      window.removeEventListener('click', handleClick, true);
      setIsOpened(false)
    } else {
      window.addEventListener('click', handleClick, true);
      setIsOpened(true);
    }
  }

  const handleClick = (event: MouseEvent) => {
    if (!containerRef.current?.contains(event.target as Node)) {
      setIsOpened(false);
    }
  }

  const findMessage = (key: string) => {
    return typeList.find((type) => type.key === key)
  }

  return (
    <S.Container onClick={handleDrop} ref={containerRef}>
      {
        type !== 'All' ? (
          <>
            <S.OptionTitle active={true}><FormattedMessage id={findMessage(type) ? findMessage(type)?.message : 'C008'} /></S.OptionTitle>
          </>
        ) : <S.OptionTitle active={true}><FormattedMessage id="C008" /></S.OptionTitle>
      }
      <S.DropdownArrow isOpened={isOpened} />
      {
        isOpened && <S.DropContainer>
          <S.DropRow
            onClick={() => updateType('All')}
          >
            { type === 'All' ? <S.ActiveTypeIcon /> : null}
            <S.OptionTitle active={type === 'All'}><FormattedMessage id="C008" /></S.OptionTitle>
          </S.DropRow>
          {
            typeList.map((item, index) => (
              <S.DropRow
                key={index}
                onClick={() => updateType(item.key)}
              >
                { type === item.key ? <S.ActiveTypeIcon /> : null}
                <S.OptionTitle active={type === item.key}><FormattedMessage id={item.message} /></S.OptionTitle>
              </S.DropRow>
            ))
          }
        </S.DropContainer>
      }
    </S.Container>
  )
}

export { CourseFilter as default };
